module.exports = "/build/web/images/logo-sikkens.a5380ee319707b11174501c6cefff227.jpeg";


//////////////////
// WEBPACK FOOTER
// ./images/logo-sikkens.jpeg
// module id = 126
// module chunks = 11